import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	title: {
		id: 'editorExtensionLinkCreate.genericError.title',
		defaultMessage: 'Something went wrong',
		description:
			'Title for the flag that shows on error of initialisation of the object creation experience',
	},
	description: {
		id: 'editorExtensionLinkCreate.genericError.description',
		defaultMessage: 'Refresh the page and try again.',
		description:
			'Description for the flag that shows on error of initialisation of the object creation experience',
	},
});
